<template>
  <div :class="['radio-input', disabled && 'disabled']">
    <label class="input-wrapper" :for="id">
      <input
        :id="id"
        class="input"
        type="radio"
        :checked="checked"
        :disabled="disabled"
        @change="onChange($event.target.checked)"
      />

      <div class="indicator">
        <FontIcon v-if="checked" class="icon" name="ui_check" />
      </div>

      <span class="input-text text4">{{ text }}</span>
    </label>
  </div>
</template>

<style lang="scss">
.radio-input {
  label {
    cursor: pointer;
  }

  .input-wrapper {
    position: relative;
    margin-bottom: 0;
  }

  .input-text,
  .indicator {
    display: inline-block;
    vertical-align: middle;
  }

  .input-text {
    display: block;
    margin-left: rem(26px);
    font-size: rem(13px);
    @include setColor(--color-text);
  }

  .input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }

  .indicator {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: rem(18px);
    height: rem(18px);
    @include setColor(--color-bakground1, background-color);
    transition: 0.2s background-color;
    border-width: 1px;
    border-style: solid;
    @include setColor(--color-cta, border-color);
    border-radius: 50%;
    font-size: rem(10px);
    @include setColor(--color-text-negative);
  }

  input:checked + .indicator {
    @include setColor(--color-selection, border-color);
    @include setColor(--color-selection, background-color);
  }

  .icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &.disabled {
    opacity: 0.3;
  }
}
</style>

<script>
import FontIcon from "../../FontIcon/FontIcon";

export default {
  components: {
    FontIcon,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: String,
      default: null,
    },
  },

  methods: {
    onChange(checked) {
      if (checked) {
        this.$emit("check");
      }
    },
  },
};
</script>
